export const _exception = {
  message: 'Something went wrong',
  variation: 'error'
}

export const _SwalDelete = {
  title: 'Are you sure want to cancel?',
  text: 'You will not be able to undo this action.',
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#dc3545',
  cancelButtonColor: '#c9c9c9',
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  confirmButtonColor2: '#002988'
}
